import {EventlogState} from "./EventlogState";
import {EventlogActionType} from "./actions";
import {AnyAction} from "redux";

const initialState = new EventlogState();

const EventlogReducers = (state: EventlogState = initialState, action: AnyAction): EventlogState => {

    const actionType: EventlogActionType = action.type;

    switch (actionType) {
        case EventlogActionType.SET_CURRENT_USER:
            return state.withCurrentUser(action.currentUser);
        case EventlogActionType.SET_EVENTS:
            return state.withEvents(action.events);
        case EventlogActionType.FETCHING_EVENTS:
            return state.withFetchingEvents(action.fetching);
        case EventlogActionType.SEARCH_FILTER:
            return state.withSearchFilter(action.searchString);
        case EventlogActionType.FROM_DATE_FILTER:
            return state.withFromDateFilter(action.fromDate);
        case EventlogActionType.TO_DATE_FILTER:
            return state.withToDateFilter(action.toDate);
        case EventlogActionType.SINCE_LAST_LOGIN_FILTER:
            return state.withSinceLastLoginFilter(action.lastLogin);
        case EventlogActionType.SET_FEATURES:
            return state.withFeatures(action.features);
        case EventlogActionType.FETCHING_FEATURES:
            return state.withFetchingFeatures(action.fetchingFeatures);
        case EventlogActionType.SET_ASSOCIATIONS:
            return state.withAssociations(action.associations);
        case EventlogActionType.FETCHING_ASSOCIATIONS:
            return state.withFetchingAssociations(action.fetchingAssociations);
        case EventlogActionType.SET_MILESTONES:
            return state.withMilestones(action.milestones);
        case EventlogActionType.FETCHING_CONTRACT:
            return state.withFetchingContract(action.fetchingContract);
        case EventlogActionType.SET_FEATURE_TYPE_SUMMARY:
            return state.withFeatureTypeSummary(action.featureTypeSummary);
        case EventlogActionType.FETCHING_FEATURE_TYPE_SUMMARY:
            return state.withFetchingFeatureTypeSummary(action.fetchingFeatureTypeSummary);
        case EventlogActionType.SET_COMMENTS:
            return state.withComments(action.comments);
        case EventlogActionType.SET_FEATURE_TYPE_ISSUES:
            return state.withFeatureTypeIssues(action.featureTypeIssues);
        case EventlogActionType.SET_FEATURE_TYPE_COMMENTS:
            return state.withFeatureTypeComments(action.featureTypeComments);
        case EventlogActionType.SET_FKB_FEATURES:
            return state.withFkbFeatures(action.fkbFeatures);
        case EventlogActionType.FETCHING_FKB_FEATURES:
            return state.withFetchingFkbFeatures(action.fetchingFkbFeatures);
        case EventlogActionType.SET_NVDB_SUBMISSIONS:
            return state.withNvdbSubmissions(action.nvdbSubmissions);
        case EventlogActionType.FETCHING_NVDB_SUBMISSIONS:
            return state.withFetchingNvdbSubmissions(action.fetchingNvdbSubmissions);
        default:
            return state;
    }
};

export default EventlogReducers;